/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import { Flex, Box, Image, Text, Button } from '@chakra-ui/react';

interface Props {
  data: any;
  phoneWidth: number;
}

const PreferenceCards: React.FC<Props> = ({ data, phoneWidth }) => {
  const padding = 4;

  return (
    <Box
      w={phoneWidth - 8}
      backgroundColor="gray.200"
      borderRadius="6px"
      transition="150ms ease"
      p={`${padding}px`}
    >
      {data?.name ? (
        <>
          <Flex
            align="center"
            px={4}
            justifyContent="center"
            flexDirection="column"
          >
            <Text fontSize="md" mt={2} mb={2} textAlign="center">
              {data?.name}
            </Text>
            <Text fontSize="sm" textAlign="center" color="gray.600">
              {data.description}
            </Text>
          </Flex>
        </>
      ) : (
        <></>
      )}
      <Flex mt={4} flexWrap="wrap">
        {data?.items?.map((banner: any, index: number) => (
          <Box
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            w="50%"
            mb={4}
            pr={index % 2 === 0 ? 4 : 0}
          >
            <Image
              w="100%"
              h="100%"
              borderColor="green.500"
              borderWidth="1px"
              src={banner?.file?.url}
              style={{ objectFit: 'cover' }}
            />
          </Box>
        ))}
      </Flex>
      <Flex justifyContent="center" w="100%">
        <Button mb={3} mt={2} colorScheme="green" w="85%">
          <Text fontSize="sm" textAlign="center" color="white">
            Continuar
          </Text>
        </Button>
      </Flex>
      <Flex justifyContent="center" w="100%">
        <Button mb={3} mt={2} w="85%" colorScheme="gray">
          <Text fontSize="sm" textAlign="center" color="gray.700">
            Agora não
          </Text>
        </Button>
      </Flex>
    </Box>
  );
};

export default PreferenceCards;
